import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostReferenzenHochladenCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostReferenzenHochladenCommandService],
  exports: []
})
export class PostReferenzenHochladenCommandServiceModule { }
